module.exports = __webpack_public_path__ + "img/koltipay_logos_rgb.3b405300.svg";